import { render, staticRenderFns } from "./TargetPoint.vue?vue&type=template&id=345776ab&scoped=true"
import script from "./TargetPoint.vue?vue&type=script&lang=js"
export * from "./TargetPoint.vue?vue&type=script&lang=js"
import style0 from "./TargetPoint.vue?vue&type=style&index=0&id=345776ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345776ab",
  null
  
)

export default component.exports